import React, { createContext, useContext, useState, ReactNode } from 'react'

/** localStorage key shared with the withIncludeTest helper in @/utils/includeTestHelper. */
export const SHOW_TEST_DATA_LS_KEY = 'hoteliate.showTestData'

interface ShowTestDataContextType {
  showTestData: boolean
  setShowTestData: (v: boolean) => void
}

const ShowTestDataContext = createContext<ShowTestDataContextType | undefined>(undefined)

export const useShowTestData = (): ShowTestDataContextType => {
  const ctx = useContext(ShowTestDataContext)
  if (!ctx) throw new Error('useShowTestData must be used within ShowTestDataProvider')
  return ctx
}

interface ShowTestDataProviderProps {
  children: ReactNode
}

export const ShowTestDataProvider: React.FC<ShowTestDataProviderProps> = ({ children }) => {
  // Hydrate from localStorage so the toggle survives page reloads.
  const [showTestData, setShowTestDataState] = useState<boolean>(
    () => localStorage.getItem(SHOW_TEST_DATA_LS_KEY) === 'true'
  )

  const setShowTestData = (v: boolean) => {
    setShowTestDataState(v)
    if (v) {
      localStorage.setItem(SHOW_TEST_DATA_LS_KEY, 'true')
    } else {
      localStorage.removeItem(SHOW_TEST_DATA_LS_KEY)
    }
  }

  return (
    <ShowTestDataContext.Provider value={{ showTestData, setShowTestData }}>
      {children}
    </ShowTestDataContext.Provider>
  )
}
